import React, { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../../StyleSheets/Main.css'
import bg from '../../Resources/image.gif'
import face from "../../Resources/image2.png"
import Typewriter from 'typewriter-effect';

const MainPoster = () => {
  let i = 0; // To track the current character being typed or erased
  let wordIndex = 0; // To track which word we are currently typing
  let wordIndex2 = 0;
  let txtArray = ['coding', 'innovating', 'creating']; // Array of words
  let txtArray2 = ['Full Stack Developer','Classical Musician','Software Developer']
  let speed = Math.floor(Math.random() * 200)+100; // Speed of typing
  let waitTime = 5000; // Time to wait before erasing
  let eraseSpeed = Math.floor(Math.random() * 101)+50; // Speed of erasing
  let eraseDelay = 500; // Delay between erasing and typing again
  useEffect(() => { typeWriter(); typeWriter2()},[])
  function typeWriter() {
    let txt = txtArray[wordIndex]; // Get the current word to type
    // Typing the word
    if (i < txt.length) {
      document.getElementById("demo").innerHTML += txt.charAt(i);
      i++;
      setTimeout(typeWriter, speed);
    }
    // After typing, wait for a set time
    else if (i === txt.length) {
      setTimeout(eraseText, waitTime);
    }
  }
  function eraseText() {
    let txt = txtArray[wordIndex]; // Get the current word to erase
    // Erasing the word one character at a time
    if (i > 0) {
      document.getElementById("demo").innerHTML = txt.substring(0, i - 1);
      i--;
      setTimeout(eraseText, eraseSpeed);
    }
    // After erasing, move to the next word
    else {
      // Move to the next word in the array
      wordIndex = (wordIndex + 1) % txtArray.length;
      setTimeout(typeWriter, eraseDelay);
    }
  }
  let j = 0;
  function typeWriter2() {
    let txt2 = txtArray2[wordIndex2]; // Get the current word to type
    // Typing the word
    if (j < txt2.length) {
      document.getElementById("heading_name").innerHTML += txt2.charAt(j);
      j++;
      setTimeout(typeWriter2, speed);
    }
    // After typing, wait for a set time
    else if (j === txt2.length) {
      setTimeout(eraseText2, waitTime);
    }
  }
  function eraseText2() {
    let txt2 = txtArray2[wordIndex2]; // Get the current word to erase
    // Erasing the word one character at a time
    if (j > 0) {
      document.getElementById("heading_name").innerHTML = txt2.substring(0, j - 1);
      j--;
      setTimeout(eraseText2, eraseSpeed);
    }
    // After erasing, move to the next word
    else {
      // Move to the next word in the array
      wordIndex2 = (wordIndex2 + 1) % txtArray2.length;
      setTimeout(typeWriter2, eraseDelay);
    }
  }
  // Start the typewriter effect

  return (
    <>
      <div className="main_poster_container">
        <div className="main_poster_left_half">
          <img src={face} alt="Sadhguna Aithal" />
          {/* <img src={face} alt="Sadhguna Aithal"/> */}
        </div>
        <div className="main_poster_right_half">
          <div className="main_poster_right_moving_container">
            <div className="main_poster_content">
              <h2>I'm a <span className="typewriter-inline" id="heading_name" /></h2>
              <p>
                I'm passionate about <span className="typewriter-inline" id="demo" /><br/> and bringing my technical and musical skills together to create impactful work.
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MainPoster;
